<template>
  <div class="page-container payment-made-list">
    <div class="page-title-container">
      <h1 class="page-title">Carga de abonos</h1>
    </div>

    <div class="table-container">
      <div class="table-header">
        <div
          class="d-flex flex-column flex-md-row justify-content-between align-items-start position-relative"
        >
          <div class="w-full w-md-auto md-flex-1">
            <div
              class="d-flex justify-content-between align-items-center justify-content-lg-start"
            >
              <button
                type="button"
                class="filter d-flex align-items-center justify-content-between border-0"
                @click="showFilters = !showFilters"
              >
                <i class="ri-filter-3-line text-dark font-weight-bold"></i>
                <div>Filtrar cargas</div>
              </button>

              <div class="d-md-none">
                <button
                  type="button"
                  class="button-tooltip text-dark font-weight-bold"
                  v-b-tooltip.hover
                  title="Recargar"
                  @click="loadData()"
                >
                  <i class="ri-loop-right-line"></i>
                </button>
              </div>
            </div>
          </div>

          <section
            class="w-full w-md-auto md-flex-1 d-flex justify-content-end align-items-center mt-2 mt-md-0"
          >
            <div class="d-none d-md-flex">
              <button
                type="button"
                class="button-tooltip text-dark font-weight-bold"
                v-b-tooltip.hover
                title="Recargar"
                @click="loadData()"
              >
                <i class="ri-loop-right-line"></i>
              </button>
            </div>

            <div class="w-full w-md-auto d-flex flex-column flex-md-row">
              <SearchBar
                placeholder="Buscar por método de pago o cargado por"
                @search="onSearch"
                @input="search = $event"
                class="flex-1"
              />

              <div class="text-right mt-2 mt-md-0">
                <b-button
                  :to="{ name: 'celulares-status-made-batch-upload' }"
                  variant="none"
                  class="button button-primary ml-md-2"
                  v-if="$can('manage', 'status_pago_carga_abonos_carga')"
                  >Cargar
                </b-button>
              </div>
            </div>
          </section>

          <filter-menu
            :show="showFilters"
            @hide="showFilters = false"
            :options="filterOptions"
            :selectedOptionFilter="filters"
            @setFilters="setFilters"
          ></filter-menu>
        </div>

        <div
          class="w-100 d-flex flex-wrap align-items-center mt-2"
          v-if="showFiltersList"
        >
          <span
            v-for="(val, name) in filterList"
            v-bind:key="name"
            class="filter-item"
          >
            {{ getFilterName(name, val) }}
            <button
              type="button"
              class="text-white p-0 bg-transparent border-0 ml-2"
              @click="deleteFilter(name)"
            >
              <i class="ri-close-circle-line"></i>
            </button>
          </span>
        </div>
      </div>

      <div class="mb-0">
        <!-- Mobile -->
        <div class="custom-table-mobile d-xl-none">
          <section class="custom-table-mobile-header">
            <div>
              <span>Fecha de carga</span>
            </div>
            <div>
              <span>Cargado por</span>
            </div>
          </section>

          <div class="custom-table-mobile-body">
            <div class="custom-table-mobile-row" v-for="o in list" :key="o.id">
              <div class="custom-table-mobile-grid">
                <div>
                  <span v-local-date="o.uploadDate"></span>
                </div>

                <div>
                  <span>{{ trimEmail(o.createdBy) }}</span>
                </div>

                <div>
                  <button
                    type="button"
                    class="border-0 bg-transparent"
                    @click="o.showMobileData = !o.showMobileData"
                  >
                    <span v-if="!o.showMobileData">
                      <i class="ri-arrow-down-s-line"></i>
                    </span>
                    <span v-else>
                      <i class="ri-arrow-up-s-line"></i>
                    </span>
                  </button>
                </div>
              </div>

              <div class="pt-3" v-if="o.showMobileData">
                <ul class="list-unstyled p-0">
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Fecha de abono:</span
                    >
                    <span>{{ o.payedAt }}</span>
                  </li>
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Método de pago:</span
                    >
                    <span>{{ getPaymentMethod(o.paymentMethod).label }}</span>
                  </li>
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Estado:</span
                    >
                    <span :class="`badge ${getStatus(o.status).color}`">{{
                      getStatus(o.status).label
                    }}</span>
                  </li>
                </ul>
              </div>

              <div class="custom-table-mobile-options mt-3">
                <a href="" @click.prevent="download(o.file)" class="mr-2"
                   v-if="$can('manage', 'status_pago_carga_abonos_descarga')"
                  >Descargar constancias</a
                >
              </div>
            </div>
          </div>
        </div>

        <!-- Desktop -->
        <table class="custom-table w-100 d-none d-xl-table">
          <thead>
            <tr>
              <th>Fecha de abono</th>
              <th>Método de pago</th>
              <th>Fecha de carga</th>
              <th>Cargado por</th>
              <th>Estado</th>
              <th class="pr-md-3" v-if="$can('manage', 'status_pago_carga_abonos_descarga')">Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="o in list" :key="o.id">
              <td class="cell-center">{{ o.payedAt || '-' }}</td>
              <td class="cell-center">{{ getPaymentMethod(o.paymentMethod).label }}</td>
              <td class="cell-center pl-0" v-local-date="o.uploadDate"></td>
              <td class="cell-center">{{ trimEmail(o.createdBy) }}</td>
              <td class="cell-center pl-md-2">
                <span :class="`badge ${getStatus(o.status).color}`">{{
                  getStatus(o.status).label
                }}</span>
              </td>
              <td class="cell-center d_option pr-md-2 position-relative" v-if="$can('manage', 'status_pago_carga_abonos_descarga')">
              <DropdownTable>
                <template slot="dropdown-content">
                  <DropdownItem
                    v-if="$can('manage', 'status_pago_carga_abonos_descarga') && o.file"
                    text="Descargar constancias"
                    @click="download(o.file)"
                  />
                </template>
              </DropdownTable>
            </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-footer d-flex justify-content-end align-items-center">
        <pagination
          :total="total"
          :page="page"
          :page-size="pageSize"
          :pages="pages"
          :changePage="changePage"
          :changePageSize="changePageSize"
          v-if="list.length"
        />

        <div class="table-no-results" v-else>
          <p class="m-0 px-3">No se encontraron resultados.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Constants,
  Util,
  Alert,
  FilterMenu,
  FilterMixin,
  PaginationMixin,
  SearchBar,
  DropdownTable,
  DropdownItem
} from "wize-admin";

import { PaymentMadeBatchService } from "@/core/services";
import { Constants as LocalConstants } from "@/core/utils";

export default {
  components: {
    SearchBar,
    FilterMenu,
    DropdownTable,
    DropdownItem
  },
  data() {
    return {
      list: [],
      tooltipType: null,
      filterOptions: [
        {
          label: "Estado",
          key: "status",
          type: Constants.TypeFilters.SINGLE,
          options: [
            LocalConstants.PaymentMadeBatchStatus.ACTIVE,
            LocalConstants.PaymentMadeBatchStatus.INACTIVE,
          ],
        },
        {
          label: "Fecha de carga",
          key: "uploadDate",
          type: Constants.TypeFilters.DATE,
          isRange: true,
        },
        {
          label: "Fecha de abono",
          key: "paidAt",
          type: Constants.TypeFilters.DATE,
          isRange: true
        }
      ]
    };
  },
  mixins: [PaginationMixin, FilterMixin],
  methods: {
    getPaymentMethod(key) {
      return Util.searchValue(key, LocalConstants.PaymentMethods)
    },
    getStatus(key) {
      return Util.searchValue(key, LocalConstants.PaymentMadeBatchStatus);
    },
    async loadData() {
      try {
        await this.$store.dispatch("app/loading", true);

        const params = {
          page: this.page - 1,
          size: this.pageSize,
          sort: "createdAt,desc",
          search: this.search,
        };
        const data = { search: this.search, ...this.filters };
        const response = await PaymentMadeBatchService.list(data, params);

        this.list = response.payload.content.map((item) => {
          return {
            ...item,
            showMobileData: false,
          };
        });

        this.total = response.payload.totalElements;
        this.pages = response.payload.totalPages;
      } catch (e) {
        console.error(e);
        Alert.error(e.errors.message);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    async download(asset) {
      try {
        if (asset) {
          this.$store.dispatch("app/loading", true);

          await Util.downloadFile(asset.url, asset.name);
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.$store.dispatch("app/loading", false);
      }
    },
    trimEmail(val) {
      return Util.trimEmail(val);
    },
  },
  mounted() {
    this.loadData(this.page, this.pageSize);
  },
};
</script>

<style lang="stylus"></style>
